/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect} from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Header from "../../components/includes/Header";

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import { LoginAfterCheckLogin,unescapeHtml,escapeHtml } from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

const AdminTerms = () => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검

  const { termMode } = useParams();

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  //메뉴항목지정
  const [varTermMenu,setTermMenu] = useState('');
  const [varMenuItemTitle,setMenuItemTitle] = useState('');

  const [varTerms, setTerms] = useState({ env_condition : "", env_privacy : "",env_refund:"",env_marketing:""});

  //약관 읽어오기
  const getTermsDocument = async () => {
    await axios.post(`${process.env.REACT_APP_HOST}/_get_terms`).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0) {
          let copyData = datas.results[0];
          //문자열 변환
          copyData.env_condition = unescapeHtml(copyData.env_condition);
          copyData.env_privacy = unescapeHtml(copyData.env_privacy);
          copyData.env_refund = unescapeHtml(copyData.env_refund);
          copyData.env_marketing = unescapeHtml(copyData.env_marketing);
          setTerms(copyData);
        }
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    let sMenuName = "Service";
    let sMenuTitle = "이용약관관리";
    let sTermMenu = "env_condition";
    if(Number(termMode)===2){
      sMenuName = "Privacy";
      sMenuTitle = "개인정보처리방안관리";
      sTermMenu = "env_privacy";
    } else if(Number(termMode)===3){
      sMenuName = "Refund";
      sMenuTitle = "환불취소정책동의";
      sTermMenu = "env_refund";
    } else if(Number(termMode)===4){
      sMenuName = "Marketing";
      sMenuTitle = "마케팅정보이용동의";
      sTermMenu = "env_marketing";
    } 
    setMenuItemTitle(sMenuTitle);
    setTermMenu(sTermMenu);

    setAdminMenus({type:'ENVIRONMENT',item:sMenuName});
    console.log(varAdminMenus);
    //약관 읽어오기
    getTermsDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termMode]);

  //약관 내용 변경
  const onContentHandler = (e) => {
    const {name,value} = e.currentTarget;
    setTerms({...varTerms, [name]:value});
  }

  //약관 재저장
  const onUpdateTermsHandler = async (e) => {
    e.preventDefault();
    let prompt = "이용약관을 저장합니까?";
    if(Number(termMode)===2) prompt = "개인정보처리방안을 저장합니까?";
    else if(Number(termMode)===3) prompt = "환불취소정책동의를 저장합니까?";
    else if(Number(termMode)===4) prompt = "마케팅정보이용동의를 저장합니까?";

    if (!window.confirm(prompt)) {
          return false;
    }
    //문자열 변경
    let copyData = {...varTerms};
    copyData.env_condition = escapeHtml(copyData.env_condition);
    copyData.env_privacy = escapeHtml(copyData.env_privacy);
    copyData.env_refund = escapeHtml(copyData.env_refund);
    copyData.env_marketing = escapeHtml(copyData.env_marketing);

    //약관을 서버로 저장
    const sendData = {termMode:termMode,varTerms:copyData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_terms`, sendData).then((res) => {
      alert(res.data.message);
    });
  }

  return (
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={varMenuItemTitle} varDirection={'설정'}/>
      <div className="admin-content">
        <div className="main-box">
          <table className="write-list">
            <thead></thead>
            <tbody>
              <tr>
                <td className="term-textarea" style={{textAlign:"center",padding:"10px 0px 20px 0px"}}>
                  <textarea name={varTermMenu} value={varTerms[varTermMenu]} style={{maxWidth:"95%"}} onChange={(e)=>onContentHandler(e)} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="btn-center">
          <button className="btn" style={{maxWidth:"90px"}} onClick={(e)=>onUpdateTermsHandler(e)}>저장</button>
        </div>
      </div>
    </div>
  );
}
export default AdminTerms;